var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4339_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1132 3.27334L11.3998 2.56001L7.69984 6.26001V6.98001H8.41984L12.1132 3.27334ZM10.6665 1.82667L11.5265 0.966673C11.6189 0.873147 11.7289 0.79889 11.8502 0.74821C11.9715 0.697529 12.1017 0.671432 12.2332 0.671432C12.3646 0.671432 12.4948 0.697529 12.6161 0.74821C12.7374 0.79889 12.8474 0.873147 12.9398 0.966673L13.7065 1.73334C14.0998 2.12667 14.0998 2.76001 13.7065 3.14667L13.2532 3.60001L13.2398 3.61334L12.8532 4.00001L8.85317 8.00001H6.6665V5.82667L10.6665 1.82667ZM9.1465 1.46001L8.77984 1.82667L7.93317 2.67334C5.73317 2.70667 3.99984 4.40667 3.99984 6.80667C3.99984 8.36667 5.29984 10.4333 7.99984 12.9C10.6998 10.4333 11.9998 8.37334 11.9998 6.80667V6.74001L13.1998 5.54001C13.2865 5.94001 13.3332 6.36667 13.3332 6.80667C13.3332 9.02001 11.5532 11.64 7.99984 14.6733C4.4465 11.64 2.6665 9.02001 2.6665 6.80667C2.6665 3.48667 5.19984 1.34001 7.99984 1.34001C8.3865 1.34001 8.77317 1.38001 9.1465 1.46001Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4339_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLocation);
export default __webpack_public_path__ + "static/media/edit_location.b35ef0d82da96ba6fa3a8317f8fe9bf6.svg";
export { ForwardRef as ReactComponent };